import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = ({
  children,
  bodyClass,
  hideFooter = false,
  renderNavLanguageToggle = null,
}) => {
  useEffect(() => {
    if (!bodyClass) return undefined;
    const classes = bodyClass.split(/\s+/).filter(Boolean);
    classes.forEach((c) => document.body.classList.add(c));
    return () => classes.forEach((c) => document.body.classList.remove(c));
  }, [bodyClass]);

  return (
    <>
      <Navbar renderNavLanguageToggle={renderNavLanguageToggle} />
      <main>{children}</main>
      {!hideFooter && <Footer />}
    </>
  );
};

export default Layout;
